import i18n from "@/common/lang"

export default {
	401: i18n.t("errorCodeText1"),
	403: i18n.t("errorCodeText2"),
	404: i18n.t("errorCodeText3"),
	default: i18n.t("errorCodeText4"),
};
